import { FC } from 'react';

import { BaseSeparateModal } from 'src/models/modals';
import { UiModal } from 'src/components/UI/modal/UiModal';
import { useNsTHelper } from 'src/utils/i18n';

type Props = BaseSeparateModal & {
  onSuccess: () => void;
  successLoading: boolean;
  percent: number;
  campaignTerminologySingular: string;
};

export const TemplateGalleryDetailsScreenPricingModal: FC<Props> = ({
  onClose,
  onSuccess,
  successLoading,
  percent,
  campaignTerminologySingular,
}) => {
  const tHelper = useNsTHelper('modals.templateGallery', 'details.modals.pricing');

  return (
    <UiModal
      header={tHelper('header')}
      onHide={onClose}
      onSuccess={onSuccess}
      successLoading={successLoading}
      successBtnText={tHelper('successBtnText')}
    >
      <p>{tHelper('body', { campaignSingularTerminology: campaignTerminologySingular, percent })}</p>
    </UiModal>
  );
};
